import appConfig from "configs/app.config";
import { invokeOmsService } from "./apiService";
import { buildQueryParams } from "../utils/helper";

const appendIsArchivedQuery = (query, isArchived) => {
  if (isArchived === true || isArchived === "true") {
    query.set("isArchived", "true");
  } else if (isArchived === false || isArchived === "false") {
    query.set("isArchived", "false");
  }
};

const appendIsActiveQuery = (query, isActive) => {
  if (isActive === true || isActive === "true") {
    query.set("isActive", "true");
  } else if (isActive === false || isActive === "false") {
    query.set("isActive", "false");
  }
};

const getAccountDetails = async (accountId) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getAccountDetails.replace("{id}", accountId),
  };
  return await invokeOmsService(requestParams);
};

const getXrayCategoriesEnums = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getXrayCategoriesEnums,
  };
  return await invokeOmsService(requestParams);
};

const getRolesByAccount = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getRolesByAccount,
  };
  return await invokeOmsService(requestParams);
};

const addXrayBodyParts = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.addXrayBodyParts,
    body: body,
  };
  return await invokeOmsService(requestParams);
};

const editXrayBodyParts = async (bodyData, id) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.editXrayBodyParts.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const getXrayBodyPartById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getXrayBodyPartById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getRecordTypes = async (payload) => {
  const {
    pageNumber = 1,
    perPage = 10,
    sortBy = "description",
    sortOrder = "asc",
    nature = "",
    search = "",
    searchFields = "",
    isArchived,
    isActive,
  } = payload || {};

  const query = new URLSearchParams({
    pageNumber: String(pageNumber),
    perPage: String(perPage),
    sortBy,
    orderBy: sortOrder,
    nature,
    search,
    searchFields,
  });

  appendIsArchivedQuery(query, isArchived);
  appendIsActiveQuery(query, isActive);

  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.getRecordTypes}?${query.toString()}`,
  };

  return await invokeOmsService(requestParams);
};

const getRecordTypeById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getRecordTypeById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const editRecordType = async ({ id, ...body }) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.editRecordType.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};

const addRecordType = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.addRecordType,
    body,
  };
  return await invokeOmsService(requestParams);
};

const getRequestTypes = async (payload = {}) => {
  const {
    pageNumber = 1,
    perPage = 10,
    sortBy = "description",
    sortOrder = "asc",
    nature = "",
    search = "",
    searchFields = "",
    isArchived,
    isActive,
  } = payload;

  const query = new URLSearchParams({
    pageNumber: String(pageNumber),
    perPage: String(perPage),
    sortBy,
    orderBy: sortOrder,
    nature,
    search,
    searchFields,
  });

  appendIsArchivedQuery(query, isArchived);
  appendIsActiveQuery(query, isActive);

  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.getRequestTypes}?${query.toString()}`,
  };

  return await invokeOmsService(requestParams);
};

const getRequestTypeById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getRequestTypeById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const editRequestType = async (bodyData, id) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.editRequestType.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const addRequestType = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.addRequestType,
    body,
  };
  return await invokeOmsService(requestParams);
};

const getFlowTypes = async (payload = {}) => {
  const {
    pageNumber = 1,
    perPage = 10,
    sortBy = "createdAt",
    sortOrder = "DESC",
    search = "",
    searchFields = "",
    isArchived,
    isActive,
  } = payload;

  const query = new URLSearchParams({
    pageNumber: String(pageNumber),
    perPage: String(perPage),
    sortBy,
    orderBy: sortOrder,
    search,
    searchFields,
  });

  appendIsArchivedQuery(query, isArchived);
  appendIsActiveQuery(query, isActive);

  return await invokeOmsService({
    method: "GET",
    url: `${appConfig.v2.flowType}?${query.toString()}`,
  });
};

const getFlowTypeById = async (id) =>
  await invokeOmsService({
    method: "GET",
    url: appConfig.v2.getFlowTypeById.replace("{id}", id),
  });

const resolveFlowType = async (recordTypeId, requestTypeId) =>
  await invokeOmsService({
    method: "GET",
    url: `${appConfig.v2.resolveFlowType}?recordTypeId=${recordTypeId}&requestTypeId=${requestTypeId}`,
  });

const addFlowType = async (body) =>
  await invokeOmsService({
    method: "POST",
    url: appConfig.v2.addFlowType,
    body,
  });

const editFlowType = async (body, id) =>
  await invokeOmsService({
    method: "PUT",
    url: appConfig.v2.editFlowType.replace("{id}", id),
    body,
  });

const getServiceList = async (payload) => {
  const {
    pageIndex = 1,
    pageSize = 10,
    sortBy = "description",
    sortOrder = "asc",
    nature = "",
    search = "",
    searchFields = "",
    isArchived,
    isActive,
    usageType,
  } = payload || {};

  const query = new URLSearchParams({
    pageNumber: String(pageIndex),
    perPage: String(pageSize),
    sortBy,
    orderBy: sortOrder,
    nature,
    search,
    searchFields,
  });

  appendIsArchivedQuery(query, isArchived);
  appendIsActiveQuery(query, isActive);
  // BASE | MODIFIER, resolved from the admin service each account service was copied from
  if (usageType) query.set("usageType", usageType);

  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.getServiceList}?${query.toString()}`,
  };

  return await invokeOmsService(requestParams);
};

const addServiceList = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.addServiceList,
    body,
  };
  return await invokeOmsService(requestParams);
};

const editServiceList = async (bodyData, id) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.editServiceList.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const getServiceListById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getServiceListById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getServiceMapping = async (payload = {}) => {
  const {
    pageNumber = 1,
    perPage = 10,
    sortBy = "description",
    orderBy = "asc",
    search = "",
    searchFields = "",
    isArchived,
    isActive,
  } = payload;

  const query = new URLSearchParams({
    pageNumber: String(pageNumber),
    perPage: String(perPage),
    sortBy,
    orderBy,
    search,
    searchFields,
  });

  appendIsArchivedQuery(query, isArchived);
  appendIsActiveQuery(query, isActive);

  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.getServiceMapping}?${query.toString()}`,
  };

  return await invokeOmsService(requestParams);
};

const getServiceMappingById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getServiceMappingById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const addServiceMapping = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.addServiceMapping,
    body,
  };
  return await invokeOmsService(requestParams);
};

const editServiceMapping = async (id, bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.editServiceMapping.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const deleteServiceMapping = async (serviceFeeId) => {
  const requestParams = {
    method: "STRICT_DELETE",
    url: appConfig.v2.deleteServiceMapping.replace("{id}", serviceFeeId),
  };
  return await invokeOmsService(requestParams);
};

const getXraybodypartsList = async (payload) => {
  const {
    pageIndex = 1,
    pageSize = 10,
    sortBy = "name",
    sortOrder = "asc",
    nature = "",
    search = "",
    searchFields = "",
    isArchived,
    isActive,
  } = payload || {};

  const query = new URLSearchParams({
    pageNumber: String(pageIndex),
    perPage: String(pageSize),
    sortBy,
    orderBy: sortOrder,
    nature,
    search,
    searchFields,
  });

  appendIsArchivedQuery(query, isArchived);
  appendIsActiveQuery(query, isActive);

  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.getXraybodypartsList}?${query.toString()}`,
  };

  return await invokeOmsService(requestParams);
};

const getXraybodypartsWithFeeList = async (payload = {}) => {
  const {
    pageNumber = 1,
    perPage = 10,
    pageIndex,
    pageSize,
    search = "",
    searchFields = "",
    sortBy = "name",
    sortOrder = "ASC",
    isArchived,
    isActive,
  } = payload || {};

  const query = new URLSearchParams({
    pageNumber: String(pageNumber ?? pageIndex ?? 1),
    perPage: String(perPage ?? pageSize ?? 10),
    sortBy,
    orderBy: sortOrder,
    search: search != null ? String(search) : "",
    searchFields: searchFields != null ? String(searchFields) : "",
  });

  appendIsArchivedQuery(query, isArchived);
  appendIsActiveQuery(query, isActive);

  return await invokeOmsService({
    method: "GET",
    url: `${appConfig.v2.getXraybodypartsWithFeeList}?${query.toString()}`,
  });
};

const getCannedMessages = async (payload) => {
  const {
    pageIndex = 1,
    pageSize = 10,
    sortBy = "name",
    sortOrder = "asc",
    type = "",
    search = "",
    searchFields = "",
    isArchived,
    isActive,
  } = payload || {};

  const query = new URLSearchParams({
    pageNumber: String(pageIndex),
    perPage: String(pageSize),
    sortBy,
    orderBy: sortOrder,
    type,
    search,
    searchFields,
  });

  appendIsArchivedQuery(query, isArchived);
  appendIsActiveQuery(query, isActive);

  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.getCannedMessages}?${query.toString()}`,
  };

  return await invokeOmsService(requestParams);
};

const getParentService = async (payload = {}) => {
  const queryString = buildQueryParams(payload, {
    pageNumber: 1,
    perPage: 10,
    sortBy: "description",
    sortOrder: "asc",
    nature: "",
    search: "",
  });

  const url = `${appConfig.v2.getParentService}?${queryString}`;

  const requestParams = {
    method: "GET",
    url,
  };

  return await invokeOmsService(requestParams);
};

const getCannedMessagesById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getCannedMessagesById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const addCannedMessage = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.addCannedMessage,
    body,
  };
  return await invokeOmsService(requestParams);
};

const updateCannedMessage = async (id, bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.updateCannedMessage.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const getConfiguration = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getConfig.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const updateConfiguration = async (id, body) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.updateConfig.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};

const resendSetPassword = async (id) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.resendSetPassword.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const resendSetPasswordforEmployee = async (id) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.resendSetPasswordEmployee.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getByAccountIdwithAddress = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getByAccountIdwithAddress.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getExecutiveAgents = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.accounts.getExecutiveAgents.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getScanningAgents = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.accounts.getScanningAgents.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

export const fetchStripeSetUplink = async () => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.accounts.stripeSetupLink,
  };
  return await invokeOmsService(requestParams);
};

export const fetchInvoiceServiceMapping = async (payload) => {
  const queryString = buildQueryParams(payload, {
    pageNumber: 1,
    perPage: 10,
    sortBy: "name",
    sortOrder: "asc",
    search: "",
    recordTypeId: null,
    requestTypeId: null,
  });
  const requestParams = {
    method: "GET",
    url:
      appConfig.v2.serviceMapping.getInvoiceServiceMapping + `?${queryString}`,
  };
  return await invokeOmsService(requestParams);
};

export const fetchConfigByAccountId = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.accounts.getConfigByAccountId.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getXrayCategoryFee = async (xrayCategoryId) => {
  const requestParams = {
    method: "GET",
    url:
      appConfig.v2.xrayBodyParts.getXrayCategoryFee +
      `?fieldName=${xrayCategoryId}`,
  };
  return await invokeOmsService(requestParams);
};

export const getProcessingById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.accounts.getProcessingById.replace("{accountId}", id),
  };
  return await invokeOmsService(requestParams);
};

export const getScanningAgentsById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.accounts.getScanningAgentsById.replace("{accountId}", id),
  };
  return await invokeOmsService(requestParams);
};

const recordTypeFacilityArchiveData = async (id, body) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.recordTypeFacilityArchiveData.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};

const archiveCannedMessage = async (id, body) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.archiveCannedMessage.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};
const requestTypeFacilityArchiveData = async (id, body) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.requestTypeFacilityArchiveData.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};

const serviceListFacilityArchiveData = async (id, body) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.serviceListFacilityArchiveData.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};

const serviceMappingFacilityArchiveData = async (id, body) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.serviceMappingFacilityArchiveData.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};

const bodyPartsFacilityArchiveData = async (id, body) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.bodyPartsFacilityArchiveData.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};
const getProcessorSupportTickets = async (payload = {}) => {
  const query = buildQueryParams(payload, {
    pageNumber: 1,
    perPage: 10,
    sortBy: "id",
    orderBy: "asc",
    search: "",
  });

  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getProcessorSupportTicket + `?${query}`,
  };

  return await invokeOmsService(requestParams);
};

const getRequesterTickets = async (payload = {}) => {
  const query = buildQueryParams(payload, {
    pageNumber: 1,
    perPage: 10,
    sortBy: "id",
    orderBy: "asc",
    search: "",
  });
  const url =
    `${appConfig.v2.documentRequest.getRequesterTickets}` + `?${query}`;

  const requestParams = {
    method: "GET",
    url,
  };

  return await invokeOmsService(requestParams);
};

const getTicketById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getTicketById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};
export const smtpIntegration = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.smtpIntegration,
    body,
  };
  return await invokeOmsService(requestParams);
};

export const postSmtpForUser = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.postSmtpForUser,
    body,
  };
  return await invokeOmsService(requestParams);
};
export const faxIntegration = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.faxIntegration,
    body,
  };
  return await invokeOmsService(requestParams);
};

const getEmailIntegrations = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getEmailIntegrations,
  };
  return await invokeOmsService(requestParams);
};

const getEmailIntegrationsForUser = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getEmailIntegrationsForUser,
  };
  return await invokeOmsService(requestParams);
};

const getFaxIntegrations = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getFaxIntegrationDetails,
  };
  return await invokeOmsService(requestParams);
};

const getRingCentralAccount = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getRingCentralAccount,
  };
  return await invokeOmsService(requestParams);
};

const sendFax = async (orderId, body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.sendFax.replace("{orderId}", orderId),
    body,
  };
  return await invokeOmsService(requestParams);
};

const getEmailIntegrationsById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getEmailIntegrationsById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};
const deleteEmailIntegrations = async (id) => {
  const requestParams = {
    method: "STRICT_DELETE",
    url: appConfig.v2.deleteEmailIntegrations.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const deleteUserEmailIntegrations = async (integrationId, userId) => {
  const requestParams = {
    method: "STRICT_DELETE",
    url: appConfig.v2.deleteUserEmailIntegrations
      .replace("{id}", integrationId)
      .replace("{userId}", userId),
  };

  return await invokeOmsService(requestParams);
};

const getLoginUrlByProvider = async (provider) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getLoginUrlByProvider.replace("{provider}", provider),
  };
  return await invokeOmsService(requestParams);
};

export const postLoginUrlByProvider = async (provider, body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.postIntegrationByProvider.replace("{provider}", provider),
    body,
  };
  return await invokeOmsService(requestParams);
};

export const postAccountLoginUrlByProvider = async (provider, body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.postIntegrationAccountByProvider.replace(
      "{provider}",
      provider
    ),
    body,
  };
  return await invokeOmsService(requestParams);
};

export const postIntegrationOAuthByProvider = async (provider, body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.postIntegrationAccountByProvider.replace(
      "{provider}",
      provider
    ),
    body,
  };
  return await invokeOmsService(requestParams);
};

const getFaxIntegration = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getFaxIntegration.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getHl7Integration = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getHl7Integration.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

export const hl7Integration = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.hl7Integration,
    body,
  };
  return await invokeOmsService(requestParams);
};
export const postEmailSettings = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.postEmailSettings,
    body,
  };
  return await invokeOmsService(requestParams);
};
const supportEmail = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.supportEmail,
    body,
  };
  return await invokeOmsService(requestParams);
};

const getEmailSettings = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getEmailSettings,
  };
  return await invokeOmsService(requestParams);
};

const putEmailSettingsById = async (bodyData, id) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.putEmailSettingsById.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const getApprovedReports = async (payload) => {
  const queryString = buildQueryParams(payload, {
    pageNumber: 1,
    perPage: 10,
    sortBy: "description",
    orderBy: "asc",
  });
  let url = appConfig.v2.getApprovedReports + `?${queryString}`;
  const requestParams = {
    method: "GET",
    url,
  };
  return await invokeOmsService(requestParams);
};

const generateReport = async (bodyData) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.generateReport,
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const downloadReport = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.downloadReports.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getReportHistpry = async (payload) => {
  const queryString = buildQueryParams(payload, {
    pageNumber: 1,
    perPage: 10,
    sortBy: "createdAt",
    orderBy: "asc",
  });
  let url = appConfig.v2.getReportsHistory + `?${queryString}`;
  const requestParams = {
    method: "GET",
    url,
  };
  return await invokeOmsService(requestParams);
};

const sendGeneralEmail = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.sendGeneralEmail,
    body,
  };
  return await invokeOmsService(requestParams);
};

const updateFacilityStatus = async (id, bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.organizations.updateFacilityStatus.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const testEmailIntegration = async (type) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.testEmailIntegration.replace("{type}", type),
  };
  return invokeOmsService(requestParams);
};

const testEmailIntegrationforUser = async (type) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.testEmailIntegrationforUser.replace("{type}", type),
  };
  return invokeOmsService(requestParams);
};

const deleteAccountWithDetails = async (id) => {
  const requestParams = {
    method: "STRICT_DELETE",
    url: appConfig.v2.accounts.deleteAccountWithDetails.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const CannedMessagesCount = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.CannedMessagesCount.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const AccountService = {
  postAccountLoginUrlByProvider,
  postIntegrationOAuthByProvider,
  testEmailIntegration,
  testEmailIntegrationforUser,
  archiveCannedMessage,
  deleteUserEmailIntegrations,
  sendGeneralEmail,
  getEmailIntegrationsForUser,
  postSmtpForUser,
  putEmailSettingsById,
  getEmailSettings,
  postEmailSettings,
  postLoginUrlByProvider,
  getLoginUrlByProvider,
  hl7Integration,
  getHl7Integration,
  faxIntegration,
  getFaxIntegration,
  deleteEmailIntegrations,
  getEmailIntegrationsById,
  sendFax,
  getEmailIntegrations,
  getFaxIntegrations,
  getRingCentralAccount,
  smtpIntegration,
  bodyPartsFacilityArchiveData,
  serviceMappingFacilityArchiveData,
  serviceListFacilityArchiveData,
  requestTypeFacilityArchiveData,
  recordTypeFacilityArchiveData,
  getAccountDetails,
  getRolesByAccount,
  getXrayCategoriesEnums,
  getRecordTypes,
  getRequestTypes,
  getServiceList,
  getServiceMapping,
  getXraybodypartsList,
  getXraybodypartsWithFeeList,
  getCannedMessages,
  getConfiguration,
  updateConfiguration,
  addXrayBodyParts,
  editXrayBodyParts,
  getXrayBodyPartById,
  addServiceList,
  editServiceList,
  getServiceListById,
  getRequestTypeById,
  editRequestType,
  addRequestType,
  getFlowTypes,
  getFlowTypeById,
  resolveFlowType,
  addFlowType,
  editFlowType,
  getRecordTypeById,
  editRecordType,
  addRecordType,
  deleteServiceMapping,
  editServiceMapping,
  addServiceMapping,
  getServiceMappingById,
  getCannedMessagesById,
  addCannedMessage,
  getExecutiveAgents,
  getScanningAgents,
  updateCannedMessage,
  getParentService,
  resendSetPassword,
  fetchInvoiceServiceMapping,
  resendSetPasswordforEmployee,
  getByAccountIdwithAddress,
  fetchStripeSetUplink,
  fetchConfigByAccountId,
  getXrayCategoryFee,
  getProcessingById,
  getScanningAgentsById,
  getProcessorSupportTickets,
  getRequesterTickets,
  getTicketById,
  supportEmail,
  getApprovedReports,
  getReportHistpry,
  generateReport,
  downloadReport,
  updateFacilityStatus,
  deleteAccountWithDetails,
  CannedMessagesCount,
};

export default AccountService;
